var initTicketSort = function () {
    if ($('.dnJs-ticketOverview-container').length) {
        var object = $('.dnJs-ticketOverview-container .dnTicketTypeListItem');
        var url = $('.dnJs-ticketOverview-container').data('url-change-sort');
        var list = {};

        object.clayfy({
            type: 'sortable',
            container: '.dnJs-ticketOverview-container',
            not: '.dnTicketTypeListItem-container, .dnTicketTypeListItem-status, .dnTicketTypeListItem-ticket'
        });
        object.on('clayfy-changeorder', function (e) {
            object.each(function () {
                var hashId = $(this).attr('data-ticket-type-hash');
                var index = $(this).index();

                list[hashId] = index;
            });
            $.ajax({
                type: "POST",
                url: url,
                data: {order: JSON.stringify(list)}
            });
        });
    }
};

jQuery(document).ready(function () {
    initTicketSort();
});

$(document).on('loaded.form.ajax', function () {
    initTicketSort();
});